if (!customElements.get('component-recommendations')) {
  customElements.define('component-recommendations', class Recommendations extends HTMLElement {
    constructor() {
      super();
      this.state = {
        showingMore: false
      }
      this.props = {
        title: this.dataset.title,
        productsSource: this.dataset.productsSource,
        productId: this.cleanProductId(this.dataset.productId),
        productShowLimit: parseInt(this.dataset.productShowLimit) || 4,
        sectionId: this.dataset.sectionId,
        intent: this.dataset.intent,
        designMode: this.dataset.designMode === 'true'
      }
    }

    cleanProductId(rawProductId) {
      if (!rawProductId || rawProductId === 'undefined' || rawProductId === '') {
        return null;
      }
      if (rawProductId.includes('gid://shopify/Product/')) {
        return rawProductId.split('/').pop();
      }
      if (/^\d+$/.test(rawProductId)) {
        return rawProductId;
      }
      const match = rawProductId.match(/\d+/);
      return match ? match[0] : null;
    }

    connectedCallback() {
      const useRecommendationsAPI = this.props.productsSource === 'api';

      if (!this.props.designMode && useRecommendationsAPI) {
        this.fetchRecommendations(this.props.productId);
        document.addEventListener('update-pdp-sections', (event) => {
          this.fetchRecommendations(event.detail.productId);
        });
      }
      this.initializeShowMoreButton();
    }

    initializeShowMoreButton() {
      const showMoreBtn = this.querySelector('.feature-products-section__show-more-btn');
      if (showMoreBtn) {
        showMoreBtn.addEventListener('click', () => {
          this.handleShowMore();
        });
      }
    }

    handleShowMore() {
      console.log('Show More clicked');

      if (this.props.productsSource === 'blocks') {
        this.handleShowMoreBlocks();
      } else if (this.props.productsSource === 'api') {
        this.props.productShowLimit = 8;
        this.fetchRecommendations(this.props.productId);
      }
      const event = new CustomEvent('recommendations-show-more', {
        detail: {
          sectionId: this.props.sectionId,
          currentLimit: this.props.productShowLimit
        }
      });
      document.dispatchEvent(event);
    }

    handleShowMoreBlocks() {
      const hiddenProducts = this.querySelectorAll('.hidden-product');
      const showMoreBtn = this.querySelector('.feature-products-section__show-more-btn');

      if (hiddenProducts.length > 0) {
        hiddenProducts.forEach((product, index) => {
          setTimeout(() => {
            product.classList.remove('hidden-product');
            product.classList.add('show-more-revealed');
          }, index * 150);
        });

        if (showMoreBtn) {
          const showMoreContainer = showMoreBtn.closest('.feature-products-section__show-more');
          if (showMoreContainer) {
            showMoreBtn.style.transform = 'scale(0.8)';
            showMoreBtn.style.opacity = '0';

            setTimeout(() => {
              showMoreContainer.style.display = 'none';
            }, 300);
          }
        }

        this.state.showingMore = true;
      }
    }

    fetchRecommendations(productId) {
      const productRecommendationsSection = this.querySelector('.js-recommendations');

      if (!productId || productId === 'undefined' || productId === '') {
        this.showNoProductsMessage(productRecommendationsSection, productId, ['none']);
        return;
      }

      const apiUrl = window.Shopify.routes.root + `recommendations/products?product_id=${productId}&limit=${this.props.productShowLimit}&intent=${this.props.intent}`;

      fetch(apiUrl)
      .then(response => {
        if (response.status === 422) {
          this.showNoProductsMessage(productRecommendationsSection, productId, [this.props.intent]);
          return null;
        }

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        return response.text();
      })
      .then((text) => {
        if (!text) return;

        if (text && text.trim().length > 50) {
          const recommendationsSliderHtml = document.createElement('div');
          recommendationsSliderHtml.innerHTML = text;

          const products = recommendationsSliderHtml.querySelectorAll('.recommended-product, [data-product-id], .product-item, .product');

          if (products.length > 0) {
            this.convertSliderToGrid(recommendationsSliderHtml, productRecommendationsSection);
            return;
          }
        }

        this.showNoProductsMessage(productRecommendationsSection, productId, [this.props.intent]);
      })
      .catch((error) => {
        this.showErrorMessage(productRecommendationsSection, error);
      });
    }

    tryFetchWithIntents(productId, intents, intentIndex, container) {
      const currentIntent = intents[intentIndex] || this.props.intent;
      const apiUrl = window.Shopify.routes.root + `recommendations/products?product_id=${productId}&limit=${this.props.productShowLimit}&intent=${currentIntent}`;

      fetch(apiUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        return response.text();
      })
      .then((text) => {
          if (text && text.trim().length > 50) {
            const recommendationsSliderHtml = document.createElement('div');
            recommendationsSliderHtml.innerHTML = text;

            const products = recommendationsSliderHtml.querySelectorAll('.recommended-product, [data-product-id], .product-item, .product');
            if (products.length > 0) {
              this.convertSliderToGrid(recommendationsSliderHtml, container);
              return;
            }
          }

          if (intentIndex < intents.length - 1) {
            this.tryFetchWithIntents(productId, intents, intentIndex + 1, container);
          } else {
            this.showNoProductsMessage(container, productId, intents);
          }
      }).catch((error) => {
        if (intentIndex < intents.length - 1) {
          this.tryFetchWithIntents(productId, intents, intentIndex + 1, container);
        } else {
          this.showErrorMessage(container, error);
        }
      });
    }

    showNoProductsMessage(container, productId, triedIntents) {
      container.innerHTML = `
        <div class="container">
          <div class="feature-products-section__title-wrapper">
            <h4 class="feature-products-section__title">${this.props.title || ''}</h4>
          </div>
          <div style="text-align: center; color: #666; font-style: italic; padding: 2rem;">
            <p><strong>No recommendations available</strong></p>
          </div>
        </div>
      `;
    }

    showErrorMessage(container, error) {
      container.innerHTML = `
        <div class="container">
          <div class="feature-products-section__title-wrapper">
            <h4 class="feature-products-section__title">${this.props.title || ''}</h4>
          </div>
          <p style="text-align: center; color: #666; font-style: italic;">
            Error loading recommendations: ${error.message}
          </p>
        </div>
      `;
    }

    convertSliderToGrid(htmlContent, container) {
      if (!this.props.title) return;
      const newContainer = document.createElement('div');
      newContainer.className = 'container';

      const titleSection = document.createElement('div');
      titleSection.className = 'feature-products-section__title-wrapper';
      titleSection.innerHTML = `<h4 class="feature-products-section__title font--rules">${this.props.title}<span class="recommendations-main-title-italic font--rules">${this.props.subtitle}</span>.</h4>`;

      const grid = document.createElement('div');
      grid.className = 'feature-products-section__grid';

      const products = htmlContent.querySelectorAll('.recommended-product, [data-product-id]');
      let productCount = 0;

      products.forEach(product => {
        if (productCount < this.props.productShowLimit) {
          grid.appendChild(product.cloneNode(true));
          productCount++;
        }
      });

      newContainer.appendChild(titleSection);
      newContainer.appendChild(grid);

      if (products.length > this.props.productShowLimit) {
        const showMoreDiv = document.createElement('div');
        showMoreDiv.className = 'feature-products-section__show-more';
        showMoreDiv.innerHTML = `
          <button type="button" class="feature-products-section__show-more-btn">
            Show More
          </button>
        `;
        newContainer.appendChild(showMoreDiv);
      }

      container.innerHTML = '';
      container.appendChild(newContainer);

      this.initializeShowMoreButton();
    }

    renderGridLayout(productDivs, totalProducts) {
      if (!this.dataset.title || !this.dataset.subtitle) return;
      const productRecommendationsSection = this.querySelector('.js-recommendations');

      const container = document.createElement('div');
      container.className = 'container';

      const titleSection = document.createElement('div');
      titleSection.className = 'feature-products-section__title-wrapper';
      titleSection.innerHTML = `<h4 class="feature-products-section__title font--rules">${this.props.title} <span class="recommendations-main-title-italic font--rules">${this.props.subtitle}</span>.</h4>`;

      const grid = document.createElement('div');
      grid.className = 'feature-products-section__grid';

      productDivs.forEach(div => {
        if (div) {
          grid.appendChild(div);
        }
      });

      container.appendChild(titleSection);
      container.appendChild(grid);

      if (totalProducts > this.props.productShowLimit) {
        const showMoreDiv = document.createElement('div');
        showMoreDiv.className = 'feature-products-section__show-more';
        showMoreDiv.innerHTML = `
          <button type="button" class="feature-products-section__show-more-btn">
            Show More
          </button>
        `;
        container.appendChild(showMoreDiv);
      }

      productRecommendationsSection.innerHTML = '';
      productRecommendationsSection.appendChild(container);

      this.initializeShowMoreButton();
    }

    async processProduct(product) {
      if (product) {
        const html = await this.getProductHTML(product.handle);
        const div = document.createElement('div');
        div.innerHTML = html;
        return div;
      }
    }
    async getProductHTML(handle) {
      // Get product data
      let response = await fetch(`${window.Shopify.routes.root}products/${handle}?view=recommended-product`, {
        method: "get"
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      response = await response.text();
      return response;
    }
  })
}

if (!customElements.get('component-recommendation')) {
  customElements.define('component-recommendation', class Recommendation extends HTMLElement {
    constructor() {
      super();
    }
    async connectedCallback() {
      this.state = {
        product: {},
        siblingProduct: {}
      }
      this.dom = {
        parentComponent: this.closest('component-recommendations')
      }
      this.props = {
        parentCollectionHandle: this.dataset.parentCollectionHandle,
        swatches: this.dom.parentComponent.dataset.swatches === 'true',
        productHandle: this.dataset.productHandle,
        color: this.dataset.color,
        id: this.dataset.id
      }
      if (this.props.swatches) {
        this.state.product = await this.getProduct();
        if (this.props.parentCollectionHandle && this.state.product && this.state.product.title != null) {
          this.state.siblingProduct = this.state.product.colors[this.props.color];
          this.render();
        }
      }
    }
    async getProduct() {
      // Get product data
      let response = await fetch(`${window.Shopify.routes.root}products/${this.props.productHandle}?view=featured-product-json`, {
        method: "get"
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      response = await response.json();
      return response;
    }
    render() {
      this.renderSwatches(this);
      this.renderTags();
      this.afterRender();
    }
    renderSwatches(template) {
      if (!this.state.product?.colors) return;
      let swatchCount = 0;
      for (const color in this.state.product.colors) {
        if (this.state.product.colors[color].available) {
          swatchCount++;
          // Prepare color swatch to be added
          const colorTemplate = template.querySelector('.js-template-color').content.cloneNode(true);
          if (window.theme.colors[color]) {
            // Set CSS custom properties for swatch styling
            if (window.theme.colors[color].image) {
              colorTemplate.querySelector('.js-label').style.setProperty('--swatch-image', `url(${window.theme.colors[color].image}`);
            }
            colorTemplate.querySelector('.js-label').style.setProperty('--swatch-color', window.theme.colors[color].color);
            colorTemplate.querySelector('.js-label').style.setProperty('--swatch-border-color', '#fff');
          }
          if (color === this.props.color) {
            colorTemplate.querySelector('.js-input').checked = true;
            colorTemplate.querySelector('.js-color').classList.add("first");
          }
          const labelId = `color_${color}_${this.state.product.id}_${this.dom.parentComponent.props.sectionId}`;
          colorTemplate.querySelector('.js-label').setAttribute('for', labelId);
          colorTemplate.querySelector('.js-label').dataset.color = color;
          colorTemplate.querySelector('.js-input').value = color;
          colorTemplate.querySelector('.js-input').id = labelId;
          this.querySelector('.js-colors').appendChild(colorTemplate);
        }
      }
      // Display count of additional hidden colors on mobile
      if (swatchCount > 4) {
        const colorCountTemplateMobile = template.querySelector('.js-colors').querySelector('.js-template-color-count').content.cloneNode(true);
        colorCountTemplateMobile.querySelector('.js-color-count').innerHTML = `+${swatchCount - 4}`;
        colorCountTemplateMobile.querySelector('.js-color-count').classList.add('color-count--mobile');
        template.querySelector('.js-colors').appendChild(colorCountTemplateMobile);
      }
      // Display count of additional hidden colors on desktop
      if (swatchCount > 8) {
        const colorCountTemplateDesktop = template.querySelector('.js-colors').querySelector('.js-template-color-count').content.cloneNode(true);
        colorCountTemplateDesktop.querySelector('.js-color-count').innerHTML = `+${swatchCount - 8}`;
        colorCountTemplateDesktop.querySelector('.js-color-count').classList.add('color-count--desktop');
        template.querySelector('.js-colors').appendChild(colorCountTemplateDesktop);
      }
    }
    renderTags() {
      let displayTag;
      for (const tag in this.state.product.tags) {
        if (typeof this.state.product.tags[tag] === 'string' && this.state.product.tags[tag].includes("__label:")) {
          displayTag = this.state.product.tags[tag].replace("__label:", '');
          break;
        }
      }
      if (displayTag) {
        const tagTemplate = this.querySelector('.js-template-tag').content.cloneNode(true);
        tagTemplate.querySelector('.js-tag-text').innerHTML = displayTag;
        this.querySelector('.js-tags').append(tagTemplate);
      }
    }
    afterRender() {
      this.handleSwatchChange();
    }
    handleSwatchChange() {
      this.querySelectorAll('.js-color .js-input').forEach(color => {
        color.addEventListener('change', () => {
          // Change image
          const images = this.state.product.colors[color.value].images;
          let imageSrc = images[0].src;
          if (images[1]) {
            imageSrc = images[1].src;
          }
          if (this.state.product.colors[color.value].type === 'Panties') {
            imageSrc = images[0].src;
          }
          this.querySelector('.js-img').src = imageSrc;
          this.querySelector('.js-img').srcset = getSrcset(imageSrc, '900');
          // Update prices
          this.querySelector('.js-price').innerHTML = toMoney(this.state.siblingProduct.price, { cents: false, no_zeros: true });
          if (this.state.siblingProduct.compare_at_price > this.state.siblingProduct.price) {
            this.querySelector('.js-compare-price').innerHTML = toMoney(this.state.siblingProduct.compare_at_price, { cents: false, no_zeros: true });
          } else {
            this.querySelector('.js-compare-price').innerHTML = '';
          }
          // Update item url
          const url = this.state.product.colors[color.value].url;
          if (url) {
            this.querySelectorAll('.js-link').forEach(link => link.href = url);
          }
        });
      });
    }
  })
}
